import { CallToAction } from 'components/CallToAction'
import React from 'react'
import { IOtherOptionsSection } from 'types'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
import * as OtherIcons from 'components/Icons/Icons'
import { prepareData } from 'utils/googleData'

const Section = (props: IOtherOptionsSection) => {
    const { title, icon, descriptionClassName, descriptionItemClassName, descriptions, direction, enable, cta } = props
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const Icon = NotProductIcons[icon] || ProductIcons[icon] || OtherIcons[icon]
    return (
        <div dir={direction} className="flex space-x-4">
            {Icon && <div>{<Icon />}</div>}
            <div dir={direction} className="flex flex-col">
                <h4 className="m-0 mb-4 px-2 leading-tight">{title}</h4>
                <div className="mb-6">
                    <ul className={descriptionClassName}>
                        {descriptions?.length > 0 &&
                            descriptions.map((descriptionItem, index, direction) => {
                                return (
                                    <li key={index} className={descriptionItemClassName}>
                                        {descriptionItem.text}
                                    </li>
                                )
                            })}
                    </ul>
                </div>
                <CallToAction
                    size="sm"
                    type={cta?.type ? cta?.type : 'secondary'}
                    className="mt-auto !w-full self-start sm:w-auto"
                    to={cta?.url}
                >
                    {cta?.text}
                </CallToAction>
            </div>
        </div>
    )
}

export default function OtherOptions(props) {
    const { enable, title, options, direction } = prepareData({ props })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <>
            <h2
                dir={direction}
                className="m-0 flex items-center border-b border-dashed border-gray-accent-light pb-4 text-2xl"
            >
                <span>{title}</span>
            </h2>
            <div dir={direction} className="my-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-y-0 sm:gap-x-4">
                {options?.length > 0 &&
                    options.map((section, index) => {
                        return <Section key={index} {...section} />
                    })}
            </div>
        </>
    )
}
